import { InfoRounded } from "@mui/icons-material";
import {
  Select,
  MenuItem,
  IconButton,
  FormControl,
  InputLabel,
  OutlinedInput,
} from "@mui/material";

export const CollisionMode = Object.freeze({
  NoneSet: "None Set",
  Ignore: "Ignore",
  Overwrite: "Overwrite",
  Skip: "Skip",
});

export const SelectCollisionMode = ({
  collisionMode,
  setCollisionMode,
  showCollisionInfo = undefined,
}) => {
  return (
    <>
      {showCollisionInfo && collisionMode === CollisionMode.NoneSet && (
        <IconButton
          onClick={() => {
            showCollisionInfo();
          }}>
          <InfoRounded />
        </IconButton>
      )}
      <FormControl sx={{ width: 200 }}>
        <InputLabel id='collision-mode-label'>Collision Mode</InputLabel>
        <Select
          labelId='collision-mode-label'
          value={collisionMode}
          onChange={(e) => {
            setCollisionMode(e.target.value);
            localStorage.setItem("collisionMode", e.target.value);
          }}
          size={"small"}
          input={<OutlinedInput label='Collision Mode' />}>
          <MenuItem value={CollisionMode.NoneSet}>
            {CollisionMode.NoneSet}
          </MenuItem>
          <MenuItem value={CollisionMode.Ignore}>
            {CollisionMode.Ignore}
          </MenuItem>
          <MenuItem value={CollisionMode.Overwrite}>
            {CollisionMode.Overwrite}
          </MenuItem>
          <MenuItem value={CollisionMode.Skip}>{CollisionMode.Skip}</MenuItem>
        </Select>
      </FormControl>
    </>
  );
};
